import React from 'react';
import {NavLink} from 'react-router-dom'
import './signin.css';

const Signin = ({submitHandLer, ChangeHandler, error ,isSubmited}) => {
    return (
        <div className='app-container'>
        <div className='title-container'>
            <h3>Sign UP</h3>
        </div>
         <form className='form-container' onSubmit={submitHandLer}>
            <div className="form-group">
            <label htmlFor="email">Email address:</label>
            <input type="input"  placeholder="Enter email"
             name='email' id="email" onChange={ChangeHandler} />
             {isSubmited ? (error.emailErr ? 
                <div className='error-caption'>
                    <small>
                        {error.emailErr}<i className='fa fa-exclamation-circle'></i>
                    </small>
                </div> : <i className='fa fa-check-circle'></i>): ''}
            </div>
            <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input type="password" className="" placeholder="Enter password" 
            name='password' id="password" onChange={ChangeHandler} />
            {isSubmited ? (error.passwordErr ? 
                <div className='error-caption'>
                    <small>
                        {error.passwordErr}<i className='fa fa-exclamation-circle'></i>
                    </small>   
                </div> : <i className='fa fa-check-circle'></i>): ''}
            </div>
            <div className='button-container'>
                <button type="submit">Sign Up</button>
            </div>
            <div className='account-title'>
                <h6>
                    Don't have an account? 
            <NavLink to='/signup' style={{fontSize:'14px'}}>{' '}Register</NavLink>
                </h6>
            </div>
        </form>  
    </div>
    )
}

export default Signin
